export default "__VITE_ASSET__BrqiQ8gf__"